module.exports = __webpack_public_path__ + "img/Screen_1.08d6e6d2.png";